import React from 'react';

import { useFormContext } from 'react-hook-form';

import { FieldError, FieldWrapper, Label } from 'styles/form';

interface FieldProps {
  children: React.ReactNode;
  name?: string;
  label?: string;
}

export default function Field({ children, name, label }: FieldProps) {
  const {
    formState: { errors },
  } = useFormContext();

  // Not passing a name for the field will cause it to render a "dummy field"
  if (!name) {
    return <FieldWrapper>{children}</FieldWrapper>;
  }
  return (
    <FieldWrapper>
      {label && <Label>{label}</Label>}
      {children}
      <FieldError>{!!errors && errors[name]?.message}</FieldError>
    </FieldWrapper>
  );
}
